import { ReactNode, useEffect } from 'react';
import clsx from 'clsx';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}

export function SlideOver({ open, onClose, title, children, footer, width = 480 }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        className={clsx('fixed inset-0 z-40 bg-black/20 transition-opacity', open ? 'opacity-100' : 'opacity-0 pointer-events-none')}
        onClick={onClose}
      />
      <div
        className={clsx(
          'fixed top-0 right-0 z-50 h-full bg-surface border-l border-border shadow-lg transition-transform flex flex-col',
          open ? 'translate-x-0' : 'translate-x-full',
        )}
        style={{ width }}
      >
        {title && (
          <div className="px-5 py-4 border-b border-border-light flex items-center justify-between">
            <div className="text-base font-semibold text-text-primary">{title}</div>
            <button onClick={onClose} className="text-text-muted hover:text-text-primary text-sm">×</button>
          </div>
        )}
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && (
          <div className="px-5 py-3 border-t border-border-light bg-page flex items-center justify-end gap-2">
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
